import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PropTypes from 'prop-types';

import * as Styled from './WhatToKnowCard.style';

/**
 * A component for displaying informational content with a "What to Know" header,
 * title, description, and checklist items with checkmarks.
 *
 * @param {object} props - Component props
 * @param {string} props.title - The main title to display (e.g., "State of formation")
 * @param {string} props.description - The description paragraph text
 * @param {Array<string>} props.items - Array of checklist item strings
 */
function WhatToKnowCard({ title, description, items = [] }) {
  return (
    <Styled.CardRoot>
      <Styled.ContentContainer>
        <Styled.InfoSection>
          <Styled.Label>WHAT TO KNOW</Styled.Label>
          <Styled.Title>{title}</Styled.Title>
          <Styled.Description>{description}</Styled.Description>
        </Styled.InfoSection>

        <Styled.ChecklistSection>
          {items.map((item) => (
            <Styled.ChecklistItem key={item.id}>
              <Styled.CheckIcon>{item.icon || <CheckRoundedIcon />}</Styled.CheckIcon>
              <Styled.ChecklistText>{item.text}</Styled.ChecklistText>
            </Styled.ChecklistItem>
          ))}
        </Styled.ChecklistSection>
      </Styled.ContentContainer>
    </Styled.CardRoot>
  );
}

WhatToKnowCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object)
};

export default WhatToKnowCard;
